import React from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import Linkify from 'linkify-react';
import { elementFieldTypeEnums } from './elementFieldTypes';
import Link from '../../components/Link';
import { countries } from '../countries/countries';
import { format } from 'date-fns';
import { MULTI_SELECT_SEPARATOR } from '@repo/lib';
import Dash from '@/dashboard/components/Dash';

const joinList = list =>
  Array.isArray(list) && list.length > 0 ? list.join(MULTI_SELECT_SEPARATOR) : null;

// Selects store option values and keep the labels, as they were when answered, in meta.
function displayText(field) {
  switch (field.element) {
    case elementFieldTypeEnums.SELECT:
      return field.meta?.selectedOptionLabel || field.value;
    case elementFieldTypeEnums.MULTI_SELECT:
      return (
        field.meta?.selectedOptionLabel ||
        joinList(field.meta?.selectedOptionLabels) ||
        joinList(field.values) ||
        field.value
      );
    default:
      return field.value;
  }
}

export default function renderFieldValue(field, { icon = true } = {}) {
  const text = displayText(field);

  if (!text) return <Dash />;

  switch (field.element) {
    case elementFieldTypeEnums.EMAIL:
      return icon ? (
        <Link to={`mailto:${field.value}`} target="_blank" variant="withIcon">
          <EnvelopeIcon className="h-4 w-4 mt-0.5" />
          {field.value}
        </Link>
      ) : (
        <Link to={`mailto:${field.value}`} target="_blank" className="break-all">
          {field.value}
        </Link>
      );
    case elementFieldTypeEnums.CHECKBOX:
      return field.value === 'true' ? 'Yes' : 'No';
    case elementFieldTypeEnums.COUNTRY: {
      const country = countries.find(country => country.alpha2 === field.value);

      if (!country) return field.value;

      return `${country.name} (${country.alpha2})`;
    }
    case elementFieldTypeEnums.DATE_TIME:
      return format(new Date(field.value), 'd MMM, yyyy, HH:mm');
    case elementFieldTypeEnums.DATE:
      return format(new Date(field.value), 'd MMM, yyyy');
    default:
      return (
        <Linkify
          options={{
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'font-medium underline hover:text-gray-700 dark:hover:text-muted-foreground',
          }}
        >
          {text}
        </Linkify>
      );
  }
}
